import {createSelector} from 'reselect';

import {getAbacusTests, getSystem} from './store';
import {evaluateExperiment} from '../utils/abacusHelper';

// ha_pulse_pdp_mweb_heart_button
const getPdpMwebHeartButtonTest = createSelector(
    [getAbacusTests, getSystem],
    (abacusTests, system) => {
        /* This test won't eval for non-mobile, but just in case */
        const isMobile = system.isMobile;
        const isMwebHeartTestOn = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_mweb_heart_button',
            variant: 1,
            deferLogging: false
        });
        const mobileHeartButtonExpanded = isMobile && isMwebHeartTestOn;
        return {mobileHeartButtonExpanded};
    }
);

// ha_pulse_pdp_heart_share_buttons
const getPdpShareHeartTest = createSelector(
    [getPdpMwebHeartButtonTest, getAbacusTests, getSystem],
    (mwebHeartButtonTest, abacusTests, system) => {
        const isDeviceSm = system && system.deviceSize === 'sm';
        const isHeartShareTestVar1 = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_heart_share_buttons',
            variant: 1,
            deferLogging: false
        });

        const isHeartShareTestVar2 = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_heart_share_buttons',
            variant: 2,
            deferLogging: true
        });

        const isHeartShareTestVar3 = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_heart_share_buttons',
            variant: 3,
            deferLogging: true
        });
        const shareButtonExpanded = isHeartShareTestVar3;
        const heartButtonExpanded =
            isHeartShareTestVar1 || isHeartShareTestVar2 || isHeartShareTestVar3;
        const heartButtonInJumpNav =
            isHeartShareTestVar1 || isHeartShareTestVar2 || (isHeartShareTestVar3 && isDeviceSm);
        const shareButtonInJumpNav = isHeartShareTestVar2;
        return {
            shareButtonExpanded,
            heartButtonExpanded,
            shareButtonInJumpNav,
            heartButtonInJumpNav,
            ...mwebHeartButtonTest
        };
    }
);

export {getPdpShareHeartTest};
